module.exports = __webpack_public_path__ + "static/media/closedMail.4b214efa.svg";